import React from 'react';
import { TextInput } from 'react-admin';
import { useFormState } from 'react-final-form';
const additionalJsonProps = {
    style: { width: '100%' },
    multiline: true,
    rows: 10,
    placeholder: 'Please validate your JSON input',
    initialValue: '{}',
};
const ValueInput = (prevProps) => {
    const {
        values: { type },
    } = useFormState();
    const additionalProps = type === 'jsonMatrix' ? additionalJsonProps : {};
    const props = { ...prevProps, ...additionalProps };
    return <TextInput {...props} />;
};
const validateJson = (values) => {
    const errors = {};
    if (values.type === 'jsonMatrix') {
        try {
            JSON.parse(values.value);
        } catch (e) {
            errors.value = e;
        }
    }
    return errors;
};
// CORE-7205: force-update-version can be created with its own type or as a
// custom type, so both cases are handled
const FORCE_UPDATE_VERSION_TYPE = 'force-update-version';
// Configuration type of the form: custom entries use their custom type name
const getAppConfigurationType = ({ type, customType } = {}) =>
    type === 'custom' ? customType : type;
const isForceUpdateVersionType = (values) =>
    getAppConfigurationType(values) === FORCE_UPDATE_VERSION_TYPE;
const osVersionRegex = /^\d+(\.\d+)*$/;
const validateOsVersion = (value) =>
    !value || osVersionRegex.test(String(value).trim())
        ? undefined
        : 'Invalid version, use numbers and dots (e.g. 16.4)';
/**
 * Minimum OS version supported by the latest app release. When the user's OS
 * version is lower, the app shows the end-of-support popup instead of the
 * blocking force update screen.
 */
const MinOsVersionInputs = ({ disabled }) => {
    const { values } = useFormState();
    if (!isForceUpdateVersionType(values)) return null;
    return (
        <>
            <TextInput
                source="iosMinOsVersion"
                label="iOS minimum OS version"
                validate={validateOsVersion}
                disabled={disabled}
            />
            <TextInput
                source="androidMinOsVersion"
                label="Android minimum OS version"
                validate={validateOsVersion}
                disabled={disabled}
            />
        </>
    );
};
export {
    ValueInput,
    validateJson,
    getAppConfigurationType,
    MinOsVersionInputs,
    isForceUpdateVersionType,
    validateOsVersion,
};
